// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__HHJ2-","footer":"ModalFilter_footer__m-BQ4"};